<template>
  <v-select
    v-model="selected"
    :items="shifts"
    item-text="name"
    item-value="id"
    label="Смена"
    :loading="loading"
    :disabled="loading"
    :rules="rules"
  />
</template>


<script>
import { mapActions } from 'vuex'

export default {
  name: 'ShiftsSelector',
  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      loading: false,
      shifts: [],
    }
  },

  computed: {
    selected: {
      get() {
        return this.value
      },
      set(selected) {
        this.$emit('input', selected)
      },
    },
  },

  methods: {
    ...mapActions({
      getShifts: 'shared/getShifts',
    }),

    async load() {
      this.loading = true
      this.shifts = await this.getShifts()
      this.loading = false
    },
  },

  mounted() {
    this.load()
      .then(() => {
        this.$emit('loaded')
      })
  },
}
</script>


<style scoped lang="scss">

</style>